import React from 'react';

// The component's personal "shopping list" of icons
import { Inbox, Send, FileText, Trash2, Mail, Tag } from 'lucide-react';

const SYSTEM_ICON = {
  INBOX:   <Inbox size={20} />,
  SENT:    <Send size={20} />,
  DRAFT:   <FileText size={20} />,
  TRASH:   <Trash2 size={20} />,
  SPAM:    <Trash2 size={20} />,
  IMPORTANT:<Mail size={20} />,
  STARRED: <Mail size={20} />,
  ALL:     <Mail size={20} />,
  // Microsoft specific
  inbox: <Inbox size={20} />,
  sentitems: <Send size={20} />,
  drafts: <FileText size={20} />,
  deleteditems: <Trash2 size={20} />,
};

const EmailSidebar = ({ labels, activeFolder, onSelectFolder, onCompose, onCreateLabel }) => (
  <div className="w-64 bg-gray-50 border-r border-gray-200 p-4 flex flex-col">
    <button
      onClick={onCompose}
      className="w-full py-2 bg-blue-600 text-white rounded-md font-semibold mb-4"
    >
      Compose
    </button>
    <button
      onClick={onCreateLabel}
      className="w-full py-2 bg-green-600 text-white rounded-md font-semibold mb-6"
    >
      + New Label/Folder
    </button>
    <ul className="list-none p-0 m-0 overflow-y-auto">
      {labels.map(label => (
        <li key={label.id}>
          <button
            onClick={() => onSelectFolder(label.id)}
            className={`w-full flex items-center gap-2 px-3 py-2 rounded-md text-left ${
              activeFolder === label.id
                ? 'bg-blue-100 text-blue-700 font-semibold'
                : 'hover:bg-gray-100'
            }`}
          >
            <span>
              {SYSTEM_ICON[label.id] ||
                (label.type === 'system'
                  ? <Mail size={20} />
                  : <Tag size={20} />)}
            </span>
            <span className="truncate">{label.name}</span>
          </button>
        </li>
      ))}
    </ul>
  </div>
);

export default EmailSidebar;